import CulturesTemplateDropdown from "components/dropdowns/reactselect/CulturesTemplateDropdown";
import { WordTemplateForListViewFilePanelNew } from "components/FileUpload/SingleFilePanel";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { routes } from "utilities/routing/generatedRoutes";
import { WordTemplateForListViewNewInfo } from "./models";
import { useCurrentUser } from "common/SessionContext";

interface WordTemplateForListViewNewSectionProps {
  mainAreaId: server.dto.MainAreas
}

export const WordTemplateForListViewNewSection = (props: WordTemplateForListViewNewSectionProps) => {
  const currentUser = useCurrentUser();
  const [value, setValue] = useState<WordTemplateForListViewNewInfo>({
    title: "",
    lcid: currentUser.culture,
    file: null,
  });

  const onChange = (newData: Partial<WordTemplateForListViewNewInfo>) => {
    setValue({ ...value, ...newData });
  };

  const submit = () => {
    return uploadFileToCoreApi(
      window.CoreApi.WordTemplateForListView.Create,
      window.CoreApi.WordTemplateForListView.Create.absoluteUrl(),
      {
        culture: value.lcid,
        file: value.file,
        mainAreaId: props.mainAreaId,
        title: value.title,
      },
      {
        fileType: "docx",
        timeout: 60000,
      }
    );
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.wordTemplateForListView_List(props.mainAreaId).absolute}
    sections={[{
      key: "wordTemplateForListView",
      type: "regular",
      title: RESX.Template.DocumentTemplateForListView,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          focusOnMount
          maxLength={serverReference.constants.wordTemplate.maxTitleLength}
          value={value.title}
          onChange={(title) => { onChange({ title }); }}
        />
      }, {
        key: "lcid",
        label: RESX.Language.resxLanguage,
        renderEditNew: () => <CulturesTemplateDropdown
          value={value.lcid}
          onChange={(lcid) => onChange({ lcid })}
        />
      }]
    }, {
      key: "file",
      type: "custom",
      render: () => <WordTemplateForListViewFilePanelNew
        key="files-panel"
        selected={value.file}
        onSelected={(file) => onChange({ file })}
      />
    }]}
  />
}